import React, { useState, useEffect, useRef } from 'react';
//ACTIONS AND CONTEXT
import { useMainContext } from "../../../contexts/MainContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import icon_exit from '../../../assets/icons/icon_exit.svg';
import { Link } from "react-router-dom";

/**
    * Renders a <ButtonProfile /> Button home with setting options
    * @component
*/
const ButtonProfile = () => {
    let mainContext = useMainContext();
    const node = useRef();

    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    /**
        * Toggle menu
        * @param {object} event - Input event with the value property
    */
    const handleClick = e => {
        if (node.current.contains(e.target))
            return;
        setShowMenu(false);
    };

    return (
        <div ref={node} className="ml-2 d-inline-block position-relative menu-settings">
            <button className="btn btn-primary iconProfile" onClick={() => setShowMenu(!showMenu)}>
                <FontAwesomeIcon icon={faUser} />
            </button>
            {
                (showMenu) &&
                <div className="settings-drop-down-profile">
                    <Link to="/profile">
                        <button onClick={() => { }} className="btn btn-primary w-100 text-left buttonProfile">Perfil</button>
                    </Link>
                    <button onClick={() => { mainContext.setShowCloseSession(true) }} className="btn btn-primary w-100 text-left buttonExit">
                        Salir
                        <img className="mr-2" src={icon_exit} alt="" />
                    </button>
                </div>
            }
        </div>
    )
}
export default ButtonProfile;